<template>
	<div class="tuoshou">
		<div style="">
			<el-row>
				<el-col :span="24" >
					<div class="img">
						<!-- <img src="../../assets/img/trp2.png" alt=""> -->
					</div>
					
				</el-col>
				<el-col :span="24" >
					<div class="img">
						<!-- <img src="../../assets/img/trp2.png" alt=""> -->
					</div>
					
				</el-col>
			</el-row>
			
		</div>

	</div>
</template>
<script>
export default {
	components: {},
	data() {

		return {
			form:{
				name:'',
			}

		}
	},
	props: [],

	updated() {

	},


	mounted() {

	},

	activated() {

	},
	created() {

	},
	watch: {

	},
	methods: {

	}
}
</script>
<style lang="less" scoped>
</style>